import { t } from '@moovly/i18n';
import { IconDelete, Select } from '@moovly/ui';
import * as React from 'react';
import { FontItem } from '../../store/settings.store';
import { getWeights, getStyles } from '../../config/fonts';
import './UploadFontListItem.scss';
import { TableAction, TableCol, TableRow } from '../../../../components/Table';

interface UploadFontListItemProps {
  fontItem: FontItem;
  id: number;
  onUpdate: (id: number, property: string, value: string) => void;
  onDelete: (id: number) => void;
}
const UploadFontListItem: React.FC<UploadFontListItemProps> = ({ fontItem, id, onUpdate, onDelete }) => {
  const styles = React.useMemo(getStyles, []);
  const handleSelectChange = React.useCallback(
    (property: any) =>
      ({ value }: { value: string }) => {
        onUpdate(id, property, value);
      },
    [id, onUpdate]
  );
  const handleDelete = React.useCallback(() => {
    onDelete(id);
  }, [onDelete, id]);
  const weights = React.useMemo(() => getWeights(), []);
  return (
    <TableRow className="UploadFontListItem">
      <TableCol>{fontItem.font_file.name}</TableCol>
      <TableCol>
        <Select options={weights} onChange={handleSelectChange('weight')} />
      </TableCol>
      <TableCol>
        <Select options={styles} onChange={handleSelectChange('style')} />
      </TableCol>
      <TableCol>
        <TableAction icon={IconDelete} onClick={handleDelete} tooltip={t('fonts.tooltips.removeFontType')} />
      </TableCol>
    </TableRow>
  );
};
export default UploadFontListItem;
